import React, { useEffect, useState } from 'react';
import TableDataLayer from "../components/TableDataLayer";
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { apiCall } from "../utils/apiService";

const TemplateLayer = () => {
    const [data, setData] = useState([]);
    const fetchTemplates = async () => {
        try {
            const response = await apiCall({
                url: `templet/get-templet`,
                method: 'POST',
                body: { type: 'all' }
            });
        
            setData(response.total);
            return response
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const removeTemplate = async (id) => {
        try {
            const response = await apiCall({
                url: `templet/delete-templet`,
                method: 'POST',
                body: { id: id }
            });
            if(response.success){
                // window.location.reload();
                setData(data - 1)
                // fetchTemplates();
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };
    const columns = [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name' },
        { key: 'type', label: 'Type' },
        {
            key: 'createdAt',
            label: 'Created At',
            render: (val, row) => {
                const date = new Date(row.createdAt);
                return date.toLocaleString();
            },
        },
        {
            key: 'actions',
            label: 'Actions',
            render: (val, row) => (
                <>
                    <Link
                        onClick={()=>removeTemplate(row.id)}
                        className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                        <Icon icon="mingcute:delete-2-line" />
                    </Link>
                </>

            ),
        },
    ];

    useEffect(() => {
        document.title = 'Template List'
        // fetchTemplates();
    }, [])

    return (
        <>
            {/* TableDataLayer */}
            <div className="card basic-data-table">
                <div className="card-header">
                    <div className="d-flex justify-content-between alig-items-center">
                        <h5 className="card-title mb-0">Template List</h5>
                        <div>
                            {/* <Link to="/scan-instance" className="btn btn-success">Scan Instance</Link> */}
                        </div>
                    </div>
                </div>
                <TableDataLayer
                    columns={columns}
                    totalRows={data}
                    fetchData={fetchTemplates}
                />
            </div>
        </>
    );
}

export default TemplateLayer